export const getStagedDealsUpdates = state => state.stagedDealsUpdates;